import { openBlock as o, createElementBlock as t, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(a, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M7.5 18q-1.86 0-3.18-1.28Q3 15.441 3 13.592q0-1.584.961-2.823a4.26 4.26 0 0 1 2.516-1.585 5.5 5.5 0 0 1 2.046-3.026A5.62 5.62 0 0 1 12 5q2.393 0 4.06 1.655 1.668 1.656 1.667 4.032 1.412.163 2.343 1.209.93 1.046.93 2.448 0 1.523-1.073 2.59Q18.852 18 17.318 18h-4.5a1.58 1.58 0 0 1-1.155-.477 1.56 1.56 0 0 1-.481-1.148v-4.184l-1.31 1.259-1.145-1.137L12 9.063l3.273 3.25-1.146 1.137-1.309-1.26v4.185h4.5q.86 0 1.452-.59.594-.588.594-1.441t-.594-1.442a1.98 1.98 0 0 0-1.452-.59h-1.227v-1.624q0-1.687-1.196-2.875Q13.698 6.625 12 6.625T9.106 7.813 7.91 10.688H7.5q-1.186 0-2.025.832a2.73 2.73 0 0 0-.839 2.011q0 1.179.839 2.011.84.833 2.025.833h2.045V18z"
    }, null, -1)
  ])]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
